// extracted by mini-css-extract-plugin
export default {"header":"LV","discountBanner":"MV","logo":"NV","maincontainer":"OV","videocontainer":"PV","videowelcome":"QV","videowrapper":"RV","videosale":"SV","loadingcontainer":"TV","footer":"UV","footerbutton":"VV","video":"WV","logoname":"XV"};
    if(module.hot) {
      // 1738064243151
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  